import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bullets = ['6 tomos completos de menor a mayor dificultad', 'Reglas, estrategia, psicología y juego en pareja', 'Sistema paso a paso desde cero absoluto', 'Tácticas para ganar aunque no ligues buenas cartas', 'Cómo leer al rival antes de que tire la primera carta', 'Funciona en asado, juntada y torneo'];
  return <section className="relative overflow-hidden bg-noise" data-id="element-84">
      {/* Background gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-truco-gold/10 rounded-full blur-[120px] -z-10" data-id="element-85" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-truco-red/5 rounded-full blur-[100px] -z-10" data-id="element-86" />

      {/* ===== SINGLE VIEWPORT SECTION ===== */}
      <div className="h-[100dvh] flex flex-col px-4 sm:px-6 lg:px-8 relative z-10 max-w-3xl mx-auto w-full" data-id="element-87">
        {/* TOP: Intro + hook — compacto */}
        <div className="shrink-0 text-center pt-3 pb-1" data-id="element-88">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.4
        }} className="text-truco-gold font-medium text-xs sm:text-sm uppercase tracking-wider leading-snug mb-1" data-id="element-89">
            Para el que juega al Truco hace años y siente que siempre hay
            alguien que le gana…
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-black text-truco-cream leading-[1.1] text-balance" data-id="element-90">
            ¿Seguís perdiendo al Truco aunque creés que jugás bien?
          </motion.h2>
        </div>

        {/* Product image — real mockup, fills available middle space */}
        <motion.a href="#pricing" onClick={scrollToPricing} initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="flex-1 flex items-center justify-center min-h-0 cursor-pointer" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/hY2sUxsBoqCjSdVwp5bN2a/heylloyd-image-1773951237816-removebg-preview.png" alt="La Biblia del Truco Argentino — Mockup del producto" className="max-h-full w-auto object-contain drop-shadow-[0_0_40px_rgba(212,168,83,0.3)]" data-id="element-92" />
        </motion.a>

        {/* Bottom block: title + badge + bullets + CTA — ultra compact */}
        <motion.div initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} className="shrink-0 pb-3 text-center" data-id="element-93">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-black text-transparent bg-clip-text bg-gradient-to-r from-truco-gold via-[#FFE5A3] to-truco-gold leading-tight" data-id="element-94">
            LA BIBLIA DEL TRUCO ARGENTINO™
          </h1>

          <div className="flex items-center justify-center gap-2 mt-1 mb-1" data-id="element-95">
            <span className="bg-truco-red text-white px-2.5 py-0.5 rounded-full text-[11px] sm:text-sm font-bold" data-id="element-96">
              NUEVO — 6 Tomos + 3 Bonos
            </span>
            <span className="text-[11px] sm:text-sm text-truco-creamMuted" data-id="element-97">
              Descarga inmediata
            </span>
          </div>

          <ul className="grid grid-cols-2 gap-x-2 gap-y-0 text-left max-w-sm mx-auto mb-2" data-id="element-98">
            {bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-1" data-id="element-99">
                <CheckCircle2Icon className="w-3.5 h-3.5 text-truco-gold shrink-0 mt-[2px]" data-id="element-100" />
                <span className="text-[11px] sm:text-xs leading-snug text-truco-cream" data-id="element-101">
                  {bullet}
                </span>
              </li>)}
          </ul>

          <a href="#pricing" onClick={scrollToPricing} className="block w-full sm:w-auto sm:inline-block bg-gradient-to-r from-truco-gold to-[#e6c070] text-truco-dark font-heading font-bold text-sm sm:text-base px-6 py-2.5 rounded-lg shadow-[0_0_30px_rgba(212,168,83,0.4)] text-center active:scale-95 transition-transform" data-id="element-102">
            ✅ SÍ, QUIERO LA BIBLIA DEL TRUCO COMPLETA →
          </a>
        </motion.div>
      </div>
    </section>;
}